import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

export default class CreatePaymentForTicketing {
    static buildRequest(pOrderId,pPaymentSettingsId,pIsRetryPayment,pSelPaySubDetail) {
        let returnValue = null;
        try {

            if (pOrderId&&pPaymentSettingsId) {
                let body = {
                    "orderId": pOrderId,
                    "paymentSettingsId":pPaymentSettingsId,
                    "isRetry":pIsRetryPayment,
                    "ref_staffName":pSelPaySubDetail.ref_staffName,
                    "remarks": pSelPaySubDetail.remarks,
                    "subAgentId": pSelPaySubDetail.subAgentId,
                    "paidAmount":pSelPaySubDetail.paidAmount
                };


                returnValue = body;
            } else {
                returnValue = null;
            }
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_CREATE_PAYMENT_FOR_TICKETING,
                "error in building body for Create Payment for ticketing  api",
                err.toString(),
                "buildRequest",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(
                SERVICE_URL.API_CREATE_PAYMENT_FOR_TICKETING,
                pReqOptions
            );
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_CREATE_PAYMENT_FOR_TICKETING,
                "error in getting Response from Create Payment for ticketing api ",
                err.toString(),
                "getResponse",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }
}